import { Injectable } from '@angular/core';
import { BackendService } from 'app/shared/backend.service';
import CONFIG from 'config';
import { Router } from '@angular/router';
import { FormGroup,FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class AccountactivityService 
{
  
  term: FormControl;
  openAccount:boolean;
  constructor(public backendService:BackendService,
              public _router:Router)
   { 

   }
   
  //  accountNumber(value)
  // {
  //   console.log(value);
    
  //   //this.data=value;
  //    this.backendService.getData(`${CONFIG.getAccountInfo}/${value}`)
  //                                .subscribe(response=>{console.log(response);
  //                               if(response['result'])
  //                               {
  //                                  this.openAccount=response['result'];
  //                                  this._router.navigate(['/dashboard/accountactivity']); 
  //                               }
  //                               else
  //                               {
  //                                 this._router.navigate(['/dashboard/accountactivity']);
  //                               }
                                  
                                
  //                               });

  // }

}
